<template>
  <div
    :class="[{ 'slide-left': isVisible }, 'contact-buttons d-flex dir-column']"
  >
    <a
      href="https://wa.me/+201091238424"
      target="_blank"
      class="whatsapp d-flex justify-center align-center"
      data-tooltip="+201091238424"
    >
      <font-awesome-icon :icon="['fab', 'whatsapp']" />
    </a>

    <a
      href="mailto:info@al-furqanacademy.com?subject=Inquiry%20about%20services"
      class="email d-flex justify-center align-center"
      data-tooltip="info@al-furqanacademy.com"
    >
      <font-awesome-icon :icon="['far', 'envelope']" />
    </a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    handleScroll() {
      this.isVisible = scrollY > 300;
    },
    checkVisibility() {
      // Show the buttons only when scrolled more than 300px
      this.isVisible = window.scrollY > 300;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="scss" scoped>
@use "../../sass/utils/mixins" as *;
.contact-buttons {
  z-index: 999;
  position: fixed;
  bottom: 1em;
  right: 0.5em;
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  transform: translateX(150%);
  opacity: 0;
  transition: transform 0.5s ease, opacity 0.5s ease;

  &.slide-left {
    transform: translateX(0);
    opacity: 1;
  }

  a {
    width: 45px;
    height: 45px;
    font-size: 1.4em;
    border-radius: 50%;
    color: var(--background);
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    position: relative;

    @include respond-to("medium") {
      width: 60px;
      height: 60px;
      font-size: 1.8em;
    }

    &:hover {
      transform: scale(1.08);
      box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
    }

    /* ✅ Tooltip أنيق */
    &::after {
      content: attr(data-tooltip);
      position: absolute;
      right: 105%;
      top: 50%;
      transform: translateY(-50%);
      font-size: 0.5em;
      color: #fff;
      padding: 0.3em 0.6em;
      border-radius: 6px;
      opacity: 0;
      white-space: nowrap;
      pointer-events: none;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      transition: opacity 0.3s ease;
    }

    &:hover::after {
      opacity: 1;
    }

    /* ✅ ألوان متناسقة مع البوتن */
    &.whatsapp::after {
      background-color: #25d366;
    }

    &.email::after {
      background-color: #4285f4;
    }

    /* ✅ ألوان الأزرار */
    &.whatsapp {
      background-color: #25d366;
    }

    &.email {
      background-color: #4285f4;
    }
  }
}

.slide-left {
  transform: translateX(0) !important;
}
</style>
